import React from 'react';
import { formatDate, formatFileSize } from '../utils/documentFormatters';

const DocumentRow = ({ document, onDelete, deleting, compact, t }) => (
  <div className="tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-p-3">
    <div className="tw-flex tw-items-start tw-justify-between tw-gap-2">
      <a
        href={document.url}
        target="_blank"
        rel="noreferrer"
        className="tw-min-w-0 tw-flex-1 tw-truncate tw-text-sm tw-font-medium tw-text-blue-600 hover:tw-underline"
        title={document.filename}
      >
        {document.filename}
      </a>
      <button
        type="button"
        className="tw-text-xs tw-text-red-500 hover:tw-underline disabled:tw-opacity-50"
        onClick={() => onDelete(document.id)}
        disabled={deleting}
      >
        {deleting
          ? t('customerDocuments.deleting', { defaultValue: 'Eliminando...' })
          : t('customerDocuments.delete', { defaultValue: 'Eliminar' })}
      </button>
    </div>
    <p className="tw-mt-1 tw-text-[11px] tw-text-gray-500">
      {formatFileSize(document.file_size)}
      {' - '}
      {formatDate(document.created_at)}
      {!compact && document.uploader_name ? ` - ${document.uploader_name}` : ''}
    </p>
  </div>
);

export default React.memo(DocumentRow);
